import React from "react";

type Props = React.SVGProps<SVGSVGElement> & {
    title?: string;
};

const ClockLeftIcon = ({ title, ...props }: Props) => {
    return (
        <svg
            {...props}
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label={title}
        >
            {title && <title>{title}</title>}

            <g id="Icon/reloj fill">
                <g id="reloj (2) 1" clipPath="url(#clip0_138_4736)">
                    <path
                        id="Vector"
                        d="M10.5002 4.77274C9.36748 4.77274 8.26017 5.10863 7.31832 5.73796C6.37648 6.36728 5.6424 7.26175 5.20891 8.30828C4.77543 9.3548 4.66201 10.5064 4.883 11.6173C5.10399 12.7283 5.64946 13.7488 6.45043 14.5498C7.2514 15.3508 8.27191 15.8962 9.38289 16.1172C10.4939 16.3382 11.6454 16.2248 12.692 15.7913C13.7385 15.3578 14.633 14.6238 15.2623 13.6819C15.8916 12.7401 16.2275 11.6328 16.2275 10.5C16.2259 8.98154 15.6219 7.52574 14.5482 6.45203C13.4745 5.37831 12.0187 4.77438 10.5002 4.77274ZM10.9775 10.4423C10.9775 10.5232 10.957 10.6028 10.9179 10.6735C10.8787 10.7443 10.8222 10.804 10.7537 10.847L8.92093 11.9924C8.86765 12.0257 8.80835 12.0482 8.74639 12.0585C8.68443 12.0689 8.62104 12.067 8.55984 12.0528C8.49864 12.0387 8.44081 12.0126 8.38968 11.9761C8.33854 11.9397 8.2951 11.8935 8.26182 11.8402C8.22853 11.7869 8.20607 11.7276 8.19571 11.6657C8.18535 11.6037 8.1873 11.5403 8.20143 11.4791C8.21557 11.4179 8.24163 11.3601 8.27811 11.3089C8.31459 11.2578 8.36079 11.2144 8.41407 11.1811L10.023 10.1778V8.11364C10.023 7.98706 10.0732 7.86567 10.1627 7.77616C10.2522 7.68666 10.3736 7.63637 10.5002 7.63637C10.6268 7.63637 10.7482 7.68666 10.8377 7.77616C10.9272 7.86567 10.9775 7.98706 10.9775 8.11364V10.4423Z"
                        fill="currentColor"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_138_4736">
                    <rect
                        width="11.4545"
                        height="11.4545"
                        fill="white"
                        transform="translate(4.77295 4.77274)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default ClockLeftIcon;
